import React, { useEffect, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import {
  FiLogOut,
  FiUser,
  FiBell,
  FiSearch,
  FiCalendar,
  FiClock,
} from "react-icons/fi";
import {
  MdOutlineLightMode,
  MdOutlineDarkMode,
  MdSchool,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function Navbar({ darkMode, setDarkMode }) {
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    role: "Admin",
  });
  const [currentTime, setCurrentTime] = useState("");
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Load user info from localStorage
    const userName = localStorage.getItem("full_name") || "Admin Member";
    const userEmail = localStorage.getItem("email") || "";

    setUserInfo({
      name: userName,
      email: userEmail,
      role: "Admin",
    });

    // Update time every minute
    const updateTime = () => {
      const now = new Date();
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      setCurrentTime(now.toLocaleDateString("en-IN", options));
    };

    updateTime();
    const interval = setInterval(updateTime, 60000);

    // Simulated notifications (replace with real API call)
    setNotifications([
      {
        id: 1,
        message: "Today's attendance deadline in 2 hours",
        time: "10:30 AM",
        type: "urgent",
      },
      {
        id: 2,
        message: "3 students have low attendance",
        time: "Yesterday",
        type: "warning",
      },
      {
        id: 3,
        message: "System maintenance scheduled for Sunday",
        time: "2 days ago",
        type: "info",
      },
    ]);

    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const unreadNotifications = notifications.length;

  return (
    <div className="bg-white dark:bg-gray-900 h-16 px-6 flex items-center border-b border-gray-200 dark:border-gray-800 justify-between w-full shadow-sm">
      {/* Left Section - College Info & Time */}
      <div className="flex items-center gap-6">
        {/* College Badge */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 flex items-center justify-center shadow-lg">
            <MdSchool className="text-white text-xl" />
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-semibold text-gray-900 dark:text-white">
              Gokhale Memorial Girls' College
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Attendance Management System
            </p>
          </div>
        </div>

        {/* Current Time */}
        <div className="hidden lg:block border-l border-gray-200 dark:border-gray-700 pl-6">
          <div className="flex items-center gap-2">
            <FiClock className="text-purple-600 dark:text-purple-400" />
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {currentTime}
            </p>
          </div>
        </div>
      </div>

      {/* Right Section - Controls */}
      <div className="flex items-center gap-4">
        {/* Theme Toggle */}
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="p-2.5 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 relative"
          title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          {darkMode ? (
            <MdOutlineLightMode className="text-xl text-yellow-400" />
          ) : (
            <MdOutlineDarkMode className="text-xl" />
          )}
        </button>

        {/* Notifications */}
        {/* <Menu as="div" className="relative">
          <Menu.Button className="p-2.5 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-xl transition text-gray-600 dark:text-gray-400 hover:text-purple-600 dark:hover:text-purple-400 relative">
            <FiBell className="text-xl" />
            {unreadNotifications > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center animate-pulse">
                {unreadNotifications}
              </span>
            )}
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-150"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-80 origin-top-right bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50 max-h-96 overflow-y-auto">
              <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
                <p className="text-sm font-semibold text-gray-900 dark:text-white">
                  Notifications
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  {unreadNotifications} unread
                </p>
              </div>
              <div className="py-2">
                {notifications.length > 0 ? (
                  notifications.map((notification) => (
                    <Menu.Item key={notification.id}>
                      {({ active }) => (
                        <div className={`px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition ${notification.type === 'urgent' ? 'border-l-4 border-red-500' : notification.type === 'warning' ? 'border-l-4 border-yellow-500' : 'border-l-4 border-blue-500'}`}>
                          <p className="text-sm text-gray-900 dark:text-white">
                            {notification.message}
                          </p>
                          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                            {notification.time}
                          </p>
                        </div>
                      )}
                    </Menu.Item>
                  ))
                ) : (
                  <div className="px-4 py-6 text-center">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      No notifications
                    </p>
                  </div>
                )}
              </div>
              <div className="py-2">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${active ? "bg-gray-50 dark:bg-gray-700" : ""} flex items-center justify-center gap-2 w-full px-4 py-2 text-sm text-purple-600 dark:text-purple-400`}
                      onClick={() => setNotifications([])}
                    >
                      Mark all as read
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu> */}

        {/* User Profile */}
        <Menu as="div" className="relative">
          <div className="flex items-center gap-3">
            <div className="text-right hidden md:block">
              <p className="text-sm font-semibold text-gray-900 dark:text-white truncate max-w-[150px]">
                {userInfo.name}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {userInfo.role}
              </p>
            </div>
            <Menu.Button className="flex items-center gap-2 hover:ring-2 hover:ring-purple-500 dark:hover:ring-purple-400 rounded-full p-1 transition-all duration-200 focus:outline-none">
              <div className="h-11 w-11 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 border-2 border-white dark:border-gray-800 flex items-center justify-center text-white font-bold text-lg shadow-lg hover:scale-105 transition-transform">
                {userInfo.name.charAt(0).toUpperCase()}
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-150"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute right-0 mt-2 w-64 origin-top-right bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 rounded-xl shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
              {/* User Info */}
              <div className="px-4 py-3">
                <p className="text-sm text-gray-700 dark:text-gray-300">
                  Signed in as
                </p>
                <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                  {userInfo.name}
                </p>
                <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                  {userInfo.email}
                </p>
              </div>

              {/* Quick Actions */}
              <div className="py-2">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${active ? "bg-gray-100 dark:bg-gray-700" : ""} flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300`}
                      onClick={() => navigate("/dashboard")}
                    >
                      <FiUser />
                      Dashboard
                    </button>
                  )}
                </Menu.Item>
                {/* <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${active ? "bg-gray-100 dark:bg-gray-700" : ""} flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300`}
                      onClick={() => navigate("/dashboard/profile")}
                    >
                      <FiUser />
                      Profile Settings
                    </button>
                  )}
                </Menu.Item> */}
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${active ? "bg-gray-100 dark:bg-gray-700" : ""} flex items-center gap-3 w-full px-4 py-2.5 text-sm text-gray-700 dark:text-gray-300`}
                      onClick={() => setDarkMode(!darkMode)}
                    >
                      {darkMode ? (
                        <MdOutlineLightMode />
                      ) : (
                        <MdOutlineDarkMode />
                      )}
                      {darkMode ? "Light Mode" : "Dark Mode"}
                    </button>
                  )}
                </Menu.Item>
              </div>

              {/* Logout */}
              <div className="py-2">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={`${active ? "bg-red-50 dark:bg-red-900/20" : ""} flex items-center gap-3 w-full px-4 py-2.5 text-sm text-red-600 dark:text-red-400`}
                      onClick={handleLogout}
                    >
                      <FiLogOut />
                      Logout
                    </button>
                  )}
                </Menu.Item>
              </div>

              {/* College Info Footer */}
              <div className="px-4 py-2 border-t border-gray-200 dark:border-gray-700">
                <p className="text-xs text-center text-gray-500 dark:text-gray-400">
                  Gokhale Memorial Girls' College
                </p>
                <p className="text-xs text-center text-gray-400 dark:text-gray-500">
                  ESTD 1938
                </p>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </div>
  );
}
